import { mq } from '@/utils/mediaQuery';
import styled from '@emotion/styled';

export const Container = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '6rem',

  padding: '8rem 1.6rem',
}));

export const InputForm = styled.form(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',

  maxWidth: '58rem',
}));

export const InputRows = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 0,
  flexDirection: 'column',

  '>*': {
    width: '100%',
    minHeight: '8rem',
  },

  [mq('tablet')]: {
    gap: '2.4rem 1.6rem',
    flexDirection: 'row',

    '>*': {
      width: '48%',
      minWidth: '48% !important',
    },
  },

  [mq('desktop')]: {
    gap: '2.4rem 1.6rem',
    flexDirection: 'row',

    '>*': {
      width: '48%',
    },
  },
}));

export const ButtonWrapper = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
  height: '6rem',
  gap: '0 1.6rem',
  marginTop: '6rem',
}));

export const ButtonContent = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.6rem',
}));
